var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newVoucher"},[_c('div',{staticClass:"goCar",on:{"click":_vm.goCar}}),_c('img',{attrs:{"src":"https://cms.dafang24.com/aliapp/20191012/newMember.png"}})])}
var staticRenderFns = []

export { render, staticRenderFns }